export enum IPageStatus {
    LAUNCH = 'LAUNCH', // 开售
    MEMBER = 'MEMBER', // 会员倒计时
}
